import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// Components
import PageContainer from "../../components/PageContainer/PageContainer";
import { SinProductos } from "../../components/Modals";
import "dayjs/locale/es";
import { URLs } from "../../utils/redirectStep";
import { getSessionDocument } from "services/sessionStorageService";

function CedulaRechazada() {
  const navigate = useNavigate();
  const modal = {
    open: true,
    showX: true,
    content: <SinProductos />,
  };

  useEffect(() => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(URLs.home);
    }
  }, []);

  const handleModalCloseClick = () => {
    window.location.href = "https://italmundo.com.uy/";
  };

  return (
    <PageContainer
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.rechazada}
      noImage={true}
    ></PageContainer>
  );
}

export default CedulaRechazada;
